<template>
    <div>
        <div class="banner">
            <div class="headerReplacementPublishedDocsInfo"></div>
            <div class="banner-text">
                <b>ดาวน์โหลดเอกสารนักลงทุนสัมพันธ์</b>
                <div class="breadcrumb">
                    <span><router-link to="/" class="pe-auto">หน้าหลักนักลงทุนสัมพันธ์</router-link></span>
                    <span class="separator"></span>
                    <span>เอกสารเผยแพร่</span>
                    <span class="separator"></span>
                    <span><b>ดาวน์โหลดเอกสารนักลงทุนสัมพันธ์</b></span>
                </div>
            </div>
        </div>

        <div class="container mb-5">
            <div class="TabMenu mb-5">
                <PublishedDocsInfoTabMenu />
            </div>

            <div class="row">
                <div class="col-md-4">
                    <div class="card border border-0 ">
                        <div class="card-header bg-dark text-white fw-bold rounded-0">
                            2567
                        </div>
                        <div class="card-body" style="background-color: #FBFBFB;">
                            <blockquote class="blockquote mb-2">
                                <p><i class="fa-regular fa-file-lines"></i>
                                    <b> แบบ 56-1 One Report</b>
                                </p>
                            </blockquote>
                            <div class="fw-bold">งบการเงิน</div>
                            <div><input class="form-check-input" type="checkbox" value=""></div>
                            <div><label class="form-check-label">Q1</label></div>
                            <hr>
                            <div class="fw-bold">คำอธิบายและการวิเคราะห์ของฝ่ายจัดการ</div>
                            <div><input class="form-check-input" type="checkbox" value=""></div>
                            <div><label class="form-check-label">Q1</label></div>
                            <hr>
                            <div class="fw-bold">ดาวน์โหลดทั้งหมด <input class="form-check-input" type="checkbox" value="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card border border-0">
                        <div class="card-header bg-dark text-white fw-bold rounded-0">
                            2566
                        </div>
                        <div class="card-body" style="background-color: #FBFBFB;">
                            <blockquote class="blockquote mb-2">
                                <p><i class="fa-regular fa-file-lines"></i>
                                    <b> แบบ 56-1 One Report <input class="form-check-input" type="checkbox" value=""></b>
                                </p>
                            </blockquote>
                            <div class="fw-bold">งบการเงิน</div>
                            <div class="row">
                                <div class="col-md-3">
                                    <div><input class="form-check-input" type="checkbox" value=""></div>
                                    <div><label class="form-check-label">Q1</label></div>
                                </div>
                                <div class="col-md-3">
                                    <div><input class="form-check-input" type="checkbox" value=""></div>
                                    <div><label class="form-check-label">Q2</label></div>
                                </div>
                                <div class="col-md-3">
                                    <div><input class="form-check-input" type="checkbox" value=""></div>
                                    <div><label class="form-check-label">Q3</label></div>
                                </div>
                                <div class="col-md-3">
                                    <div><input class="form-check-input" type="checkbox" value=""></div>
                                    <div><label class="form-check-label">Q4</label></div>
                                </div>
                            </div>
                            <hr>
                            <div class="fw-bold">คำอธิบายและการวิเคราะห์ของฝ่ายจัดการ</div>
                            <div class="row">
                                <div class="col-md-3">
                                    <div><input class="form-check-input" type="checkbox" value=""></div>
                                    <div><label class="form-check-label">Q1</label></div>
                                </div>
                                <div class="col-md-3">
                                    <div><input class="form-check-input" type="checkbox" value=""></div>
                                    <div><label class="form-check-label">Q2</label></div>
                                </div>
                                <div class="col-md-3">
                                    <div><input class="form-check-input" type="checkbox" value=""></div>
                                    <div><label class="form-check-label">Q3</label></div>
                                </div>
                                <div class="col-md-3">
                                    <div><input class="form-check-input" type="checkbox" value=""></div>
                                    <div><label class="form-check-label">Q4</label></div>
                                </div>
                            </div>
                            <hr>
                            <div class="fw-bold">ดาวน์โหลดทั้งหมด <input class="form-check-input" type="checkbox" value="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="card border border-0">
                        <div class="card-header bg-dark text-white fw-bold rounded-0">
                            2566
                        </div>
                        <div class="card-body" style="background-color: #FBFBFB;">
                            <blockquote class="blockquote mb-2">
                                <p><i class="fa-regular fa-file-lines"></i>
                                    <b> แบบ 56-1 One Report <input class="form-check-input" type="checkbox" value=""></b>
                                </p>
                            </blockquote>
                            <div class="fw-bold">งบการเงิน</div>
                            <div class="row">
                                <div class="col-md-3">
                                    <div><input class="form-check-input" type="checkbox" value=""></div>
                                    <div><label class="form-check-label">Q1</label></div>
                                </div>
                                <div class="col-md-3">
                                    <div><input class="form-check-input" type="checkbox" value=""></div>
                                    <div><label class="form-check-label">Q2</label></div>
                                </div>
                                <div class="col-md-3">
                                    <div><input class="form-check-input" type="checkbox" value=""></div>
                                    <div><label class="form-check-label">Q3</label></div>
                                </div>
                                <div class="col-md-3">
                                    <div><input class="form-check-input" type="checkbox" value=""></div>
                                    <div><label class="form-check-label">Q4</label></div>
                                </div>
                            </div>
                            <hr>
                            <div class="fw-bold">คำอธิบายและการวิเคราะห์ของฝ่ายจัดการ</div>
                            <div class="row">
                                <div class="col-md-3">
                                    <div><input class="form-check-input" type="checkbox" value=""></div>
                                    <div><label class="form-check-label">Q1</label></div>
                                </div>
                                <div class="col-md-3">
                                    <div><input class="form-check-input" type="checkbox" value=""></div>
                                    <div><label class="form-check-label">Q2</label></div>
                                </div>
                                <div class="col-md-3">
                                    <div><input class="form-check-input" type="checkbox" value=""></div>
                                    <div><label class="form-check-label">Q3</label></div>
                                </div>
                                <div class="col-md-3">
                                    <div><input class="form-check-input" type="checkbox" value=""></div>
                                    <div><label class="form-check-label">Q4</label></div>
                                </div>
                            </div>
                            <hr>
                            <div class="fw-bold">ดาวน์โหลดทั้งหมด <input class="form-check-input" type="checkbox" value="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </div>
    </div>
</template>
  
<script>
import PublishedDocsInfoTabMenu from '@/components/PublishedDocsInfoTabMenu.vue';
import Highcharts from 'highcharts';
import store from "@/store";
import { mapState } from "vuex";
import { GET_FINANCIAL_DATA } from "../../store/actions.type";

export default {
    name: 'Info',
    components: {
        PublishedDocsInfoTabMenu,
    },
    data() {
        return {
            financialData: null,
        };
    },
    methods: {
        async init() {
            let response = await store.dispatch(GET_FINANCIAL_DATA);
            if (response) {
                this.financialData = response; // Assign fetched data to local state
            } else {
                console.error('Failed to fetch financial data');
            }
        },
    },

};
</script>
<style scoped>
.card-body {
    background-color: rgb(251, 251, 251);
}

th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}

.table th {
    font-size: 0.85rem;
    font-weight: normal;
    padding: 8px;
}
</style>
  